import request from "root/js/request";

export const getAnalyticsCrossMPBarcodes = async ({
  cabinet_id,
  in_product_id,
  subject_id,
  brand_id,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/barcodes/",
    method: "get",
    params: {
      cabinet_id,
      in_product_id,
      subject_id,
      brand_id,
      ...rest,
    },
  });
  return response.data;
};
